import { PrivateAPINamespace } from '../PrivateAPINamespace';
export class AdminNamespace extends PrivateAPINamespace {
    // @ts-expect-error - TODO: implement this
    getContextIds() {
        throw new Error('Not implemented yet');
    }
    openItemSelector(_args) {
        throw new Error('Not implemented yet');
    }
}
AdminNamespace.namespace = 'admin';
//# sourceMappingURL=AdminNamespace.js.map